import { Params, QueryParamsHandling } from '@angular/router';

export enum NotificationType {
	CONFIRMATION = 'CONFIRMATION',
	WARNING = 'WARNING',
	ERROR = 'ERROR'
}

export interface NotificationConfig {
	message: string;
	type?: NotificationType;
	channel?: string;
	duration?: number;
	icon?: string;
	timestamp?: number;
	routingConfig?: NotificationRoutingConfig;
	actionConfig?: NotificationActionConfig;
}

export interface NotificationRoutingConfig {
	routerLink: string;
	routingDcrKey?: string;
	routingDcrValue?: string;
	queryParams?: Params;
	queryParamsHandling?: QueryParamsHandling;
}

export interface NotificationActionConfig {
	actionCallback: Function;
	actionDcrKey?: string;
	actionDcrValue?: string;
}
